import { colors } from "./colors";
import GlobalStyle from "./GlobalStyle.styles";

export const theme = {
  colors,
};

export default GlobalStyle;
